import React, { Component, createRef } from 'react';

// -----------------------------------------------------------------------

// Product collection

class ProductCollection extends Component
{
    constructor (props)
    {
        // Props
        super(props);

        // State
        this.state = {
            opened: true
        }

        this.function_toggle = this.function_toggle.bind(this);
    }

    function_toggle()
    {
        this.setState({
            opened: !this.state.opened
        });
    }

    render()
    {
        if (this.props.content_product_types.length > 0)
        {
            const product_types = [];
            for (let i = 0; i < this.props.content_product_types.length; i++)
            {
                if (this.props.content_product_types[i]['collection__id'] === this.props.product_collection_id)
                {
                    product_types.push(
                        <React.Fragment key={i}>
                            <ProductType
                                content_product_type={this.props.content_product_types[i]}
                                index={i}
                                ip_address={this.props.ip_address}
                                selection={this.props.selection_product_types[i]}
                                translation_language_key={this.props.translation_language_key}
                                function_selection_product_type={this.props.function_selection_product_type}
                                function_translate={this.props.function_translate} />
                        </React.Fragment>
                    );
                }
            }
            
            let class_toggle = 'product-collection-header-toggle-closed';
            if (this.state.opened === true)
                class_toggle = 'product-collection-header-toggle-opened';
            
            let class_product_collection = 'product-table-checkmark-disabled';
            let { total, total_selected } = this.props.function_selection_get_product_collection(this.props.product_collection_id);
            
            if (total === total_selected)
                class_product_collection = 'product-table-checkmark-enabled';
            
            return (
                <React.Fragment>
                    <div className="product-collection-header-container" onClick={() => this.function_toggle()}>
                        <div className="product-collection-header-title">{this.props.title}</div>
                        <div className={class_toggle}></div> 
                    </div>
                    
                    { this.state.opened === true &&
                        <React.Fragment>
                            <div className="product-table-header-container">
                                <div className="product-table-header-left" onClick={() => this.props.function_selection_product_collection(this.props.product_collection_id)}>
                                    <div className="product-table-checkmark-container">
                                        <div className={class_product_collection}></div>
                                    </div>
                                    
                                    <div className="product-table-title-product">{this.props.description}</div>
                                </div>
                                <div className="product-table-header-right">
                                    <div className="product-table-title-parking">{this.props.function_translate('product_table_parking')}</div>
                                    <div className="product-table-title-openings">{this.props.function_translate('product_table_openings')}</div>
                                    <div className="product-table-title-fillingandwidth">{this.props.function_translate('product_table_filling_and_width')}</div>
                                    <div className="product-table-title-more"></div>
                                </div>
                            </div>
                            <div className="product-table-rows-container">
                                {product_types}
                            </div>
                        </React.Fragment>
                    }
                </React.Fragment>
            );
        }
        else
        {
            return (
                <React.Fragment></React.Fragment>
            );
        };
    }   
}

// -----------------------------------------------------------------------

// Product type

class ProductType extends Component
{
    render()
    {
        let class_product_collection = 'product-table-checkmark-disabled';
        if (this.props.selection === true)
            class_product_collection = 'product-table-checkmark-enabled';

        return (
            <div className="product-table-row-container">
                <div className="product-table-row-left" onClick={() => this.props.function_selection_product_type(this.props.index)}>
                    <div className="product-table-checkmark-container">
                        <div className={class_product_collection}></div>
                    </div>
                    <div className="product-table-row-preview" style={{
                        backgroundImage: 'url('+this.props.ip_address+'/uploads/'+this.props.content_product_type['thumbnail']+')'
                    }}></div>
                    
                    <div className="product-table-row-product">
                        <div className="product-table-product-title">
                            {this.props.content_product_type['displayname_'+this.props.translation_language_key]}
                        </div>
                        <div className="product-table-product-text">
                            {this.props.content_product_type['property_dimensions']}
                            <div className="product-table-product-text-split"></div> 
                            {this.props.content_product_type['property_weightclass__application_'+this.props.translation_language_key]}
                            <div className="product-table-product-text-split"></div>
                            {this.props.content_product_type['property_weightclass__displayname_'+this.props.translation_language_key]}
                        </div>
                    </div>
                </div>
                    
                <div className="product-table-row-right">
                    { this.props.content_product_type['property_parking'] === true &&
                        <div className="product-table-row-parking">
                            <span className="tooltip2" data-tooltip={this.props.function_translate('product_tooltip_parking')}>
                                P
                            </span>
                        </div>
                    }
                    
                    <div className="product-table-row-openings">
                        { this.props.content_product_type['property_wateropening'] !== null &&
                            <React.Fragment>
                                <div className="tooltip2" data-tooltip={this.props.function_translate('product_tooltip_wateropening')}>
                                    <div className="product-table-row-openings-content">
                                        <div className="product-table-row-openings-icon-water"></div>
                                        {this.props.content_product_type['property_wateropening']+'%'}
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                        
                        { this.props.content_product_type['property_grassopening'] !== null &&
                            <React.Fragment>
                                { this.props.content_product_type['property_wateropening'] !== null &&
                                    <div className="product-table-product-text-split"></div>
                                }

                                <div className="tooltip2" data-tooltip={this.props.function_translate('product_tooltip_grassopening')}>
                                    <div className="product-table-row-openings-content">
                                        <div className="product-table-row-openings-icon-grass"></div>
                                        {this.props.content_product_type['property_grassopening']+'%'}
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                    </div>
                    
                    <div className="product-table-row-fillingandwidth">
                        { this.props.content_product_type['property_filling_gravel'] !== null &&
                            <React.Fragment>
                                <div className="tooltip2" data-tooltip={this.props.function_translate('product_tooltip_filling_gravel')}>
                                    <div className="product-table-row-fillingandwidth-content">
                                        <div className="product-table-row-fillingandwidth-icon-gravel"></div>
                                        {this.props.content_product_type['property_filling_gravel']+' kg/m²'}
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                        
                        { this.props.content_product_type['property_filling_gravel'] !== null &&
                            <div className="product-table-product-text-split"></div>
                        }

                        { (this.props.content_product_type['property_filling_grass_min'] !== null || this.props.content_product_type['property_filling_grass_max'] !== null) &&
                            <React.Fragment>
                                <div className="tooltip2" data-tooltip={this.props.function_translate('product_tooltip_filling_grass')}>
                                    <div className="product-table-row-fillingandwidth-content">
                                        <div className="product-table-row-fillingandwidth-icon-grass"></div>

                                        { this.props.content_product_type['property_filling_grass_max'] === null &&
                                            <React.Fragment>
                                                {this.props.content_product_type['property_filling_grass_min']+' kg/m²'}
                                            </React.Fragment>
                                        }

                                        { this.props.content_product_type['property_filling_grass_max'] !== null &&
                                            <React.Fragment>
                                                {this.props.content_product_type['property_filling_grass_min']+'-'+this.props.content_product_type['property_filling_grass_max']+' kg/m²'}
                                            </React.Fragment>
                                        }
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                        
                        { (this.props.content_product_type['property_filling_grass_min'] !== null || this.props.content_product_type['property_filling_grass_max'] !== null) &&
                            <div className="product-table-product-text-split"></div>
                        }
                        
                        { this.props.content_product_type['property_jointwidth'] !== null &&
                            <React.Fragment>
                                <div className="tooltip2" data-tooltip={this.props.function_translate('product_tooltip_jointwidth')}>
                                    {this.props.content_product_type['property_jointwidth']+' mm'}
                                </div>
                            </React.Fragment>
                        }

                        { this.props.content_product_type['property_jointdiameter'] !== null &&
                            <React.Fragment>
                                <div className="tooltip2" data-tooltip={this.props.function_translate('product_tooltip_jointdiameter')}>
                                    {'Ø'+this.props.content_product_type['property_jointdiameter']+' mm'}
                                </div>
                            </React.Fragment>
                        }

                        { (this.props.content_product_type['property_jointwidth'] === null && this.props.content_product_type['property_jointdiameter'] === null) &&
                            <React.Fragment>
                                <div className="tooltip2" data-tooltip={this.props.function_translate('product_tooltip_jointvariable')}>
                                    {this.props.function_translate('product_table_variable')}
                                </div>
                            </React.Fragment>
                        }
                    </div>
                    <ProductTypeDropdown
                        function_translate={this.props.function_translate} />
                </div>
            </div>
        )
    }
}

// -----------------------------------------------------------------------

// Product references

class ProductTypeDropdown extends Component
{
    constructor (props)
    {
        // Props
        super(props);

        // State
        this.state = {
            opened: false
        }

        this.toggle = this.toggle.bind(this);
        this.handle_outside_click = this.handle_outside_click.bind(this);

        this.reference = createRef();
    }

    componentDidMount()
    {
        document.addEventListener('mousedown', this.handle_outside_click);
    }

    componentWillUnmount()
    {
        document.removeEventListener('mousedown', this.handle_outside_click);
    }

    handle_outside_click(event)
    {
        if (this.reference.current && !this.reference.current.contains(event.target))
        {
            this.setState({
                toggle: false
            });
        }
    }

    toggle()
    {
        this.setState({
            toggle: !this.state.toggle
        });
    }

    render()
    {
        let dropdown_class = 'product-table-dropdown';
        if (this.state.toggle === true)
            dropdown_class = 'product-table-dropdown-opened'
        
        return (
            <React.Fragment>
                <div className={dropdown_class} onClick={this.toggle} ref={this.reference}>
                    { this.state.toggle === true &&
                        <div className="product-table-dropdown-content">
                            <a>
                                <div className="product-table-dropdown-content-row">
                                    <div className="product-table-dropdown-content-arrow"></div>
                                    <div className="product-table-dropdown-content-text">{this.props.function_translate('product_reference_productdetail')}</div>
                                </div>
                            </a>
                            <a>
                                <div className="product-table-dropdown-content-row">
                                    <div className="product-table-dropdown-content-arrow"></div>
                                    <div className="product-table-dropdown-content-text">{this.props.function_translate('product_reference_visualisation')}</div>
                                </div>
                            </a>
                        </div>
                    }
                </div>
            </React.Fragment>
        );
    }
}

// -----------------------------------------------------------------------

// Product

class Product extends Component
{
    render()
    {
        if (this.props.content_product_collections.length > 0)
        {
            const product_collections = [];
            for (let i = 0; i < this.props.content_product_collections.length; i++)
            {
                product_collections.push(
                    <React.Fragment key={i}>
                        <ProductCollection
                            content_product_types={this.props.content_product_types}
                            description={this.props.content_product_collections[i]['description_'+this.props.translation_language_key]}
                            ip_address={this.props.ip_address}
                            product_collection_id={this.props.content_product_collections[i]['id']}
                            selection_product_types={this.props.selection_product_types}
                            title={this.props.content_product_collections[i]['displayname_'+this.props.translation_language_key]}
                            translation_language_key={this.props.translation_language_key}
                            function_selection_get_product_collection={this.props.function_selection_get_product_collection}
                            function_selection_product_collection={this.props.function_selection_product_collection}
                            function_selection_product_type={this.props.function_selection_product_type}
                            function_translate={this.props.function_translate} />
                    </React.Fragment>
                );
            }
            
            return(
                <React.Fragment>
                    <div className="product-page">
                        <h2 className="product-info-title">{this.props.function_translate('product_info_title')}</h2>
                        <p className="product-info-text"></p>
                        
                        {product_collections}
                    </div>
                </React.Fragment>
            );
        }
        else
        {
            return (
                <React.Fragment></React.Fragment>
            );
        }
    }
}

export default Product